<template>
  <div class="agreement">
    <h2 class="center">
      <strong>用户服务协议</strong>
    </h2>
    <p
      class="sp_cl"
    >《用户服务协议》（以下简称“本协议”）是用户（以下称“您”或“用户”）与复星高照平台经营者上海复爱信息科技有限公司（以下简称“复星高照”）之间关于您使用复星高照平台服务时在杭州市拱墅区所订立的协议。</p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >复星高照在此特别提醒用户认真阅读、充分理解本协议中各条款，包括免除或者限制复星高照责任的免责条款及对用户的权利限制条款。请您审慎阅读并选择接受或不接受本协议。您通过网络页面点击确认或以其他方式选择接受本协议，即表示您与复星高照已达成协议并同意接受本协议的全部约定内容(尤其是加粗的文字部分)。</strong>您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉相关服务。
    </p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >您确认，在您开始注册或使用复星高照服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力，您应当是具备相应民事行为能力的自然人（十六周岁以上的未成年人，以自己的劳动收入为主要生活来源的，视为完全民事行为能力人）、法人或其他组织。若您不具备前述主体资格，请勿使用，否则复星高照有权随时中止或终止您的用户资格，您及您的家长或法定监护人（以下统称"监护人"）应承担因此而导致的一切后果。</strong>
    </p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >您对本协议的接受即视为自愿接受全部条款的约束，包括接受复星高照对任一服务条款随时所做的任何修改。本协议可由复星高照随时更新，复星高照将采用在平台公告、短信推送、电子邮件或其他方式通知用户该等修改、增加或删减的内容。一经公告，即视为上述内容已经通知到您。在复星高照修改本协议相关条款之后，如果用户不接受修改后的条款，请立即停止使用复星高照提供的服务，否则将被视为您已接受了修改后的协议。复星高照保留中止、终止或限制您继续使用本服务的权利，但该等终止、中止或限制行为并不豁免您已经进行的交易所应承担的义务。</strong>
    </p>
    <p class="sp_cl">
      <strong>一.定义</strong>
    </p>
    <p class="sp_cl">1. 复星高照平台：指由复星高照运营的复星高照网站及复星高照客户端等。</p>
    <p
      class="sp_cl"
    >2. 复星高照平台经营者：指经营复星高照平台的各法律主体，包括复星高照网经营者上海复爱信息科技有限公司及其相关服务可能存在的运营关联单位。您可随时查看复星高照平台各网站及/或客户端公示的信息以确定与您履约的法律主体。</p>
    <p class="sp_cl">3. 复星高照：复星高照平台经营者的单称或合称。</p>
    <p
      class="sp_cl"
    >4. 用户，包含注册用户和非注册用户。注册用户是指通过复星高照平台完成全部注册程序后，使用复星高照平台服务或复星高照网站资料的用户。非注册用户是指未进行注册、直接登录复星高照平台或通过其他网站进入复星高照平台直接或间接地使用复星高照平台服务或复星高照网站资料的用户。</p>
    <p class="sp_cl">5. 商家：在复星高照平台上发布信息为用户提供各项线上及线下的商品或服务的第三方经营者。</p>
    <p
      class="sp_cl"
    >6. 不可抗力：信息网络正常的设备维护，信息网络连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为而造成的不能服务或延迟服务。</p>
    <p class="sp_cl">
      <strong>二.账户使用规则</strong>
    </p>
    <p class="sp_cl">1. 如果您想使用复星高照更多服务，您必须注册相应帐户并且于注册页面上提供相关的个人信息。您必须</p>
    <p class="sp_cl">
      <strong>（1）承诺和保证：</strong>
    </p>
    <p
      class="sp_cl"
    >（a）您了解并同意，用户须对注册信息的真实性、合法性、有效性承担全部责任；用户不得冒充他人，不得利用他人的名义发布任何信息；不得恶意使用注册帐户导致其他用户误认；否则复星高照有权立即停止提供服务，您独自承担由此而产生的一切法律责任。</p>
    <p class="sp_cl">
      <strong class="sp_underLine">（b）您使用平台与复星高照产品、程序及服务的行为必须合法，您必须为自己注册帐户下的一切行为负责。</strong>
      用户应对其中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。复星高照无法且不会对因用户行为而导致的任何损失或损害承担责任。
    </p>

    <p class="sp_cl">
      <strong class="sp_underLine">
        （c）您在使用服务中的账号和密码是复星高照识别您身份及指令的唯一标识。您应妥善保管您的用户账户、登录密码、支付密码（如有）、验证码的安全，以及对通过您的账户和密码实施的行为负责。您必须将任何有可能触犯法律的，未授权使用或怀疑为未授权使用的行为在第一时间通知平台，平台不对您因此造成的损失承担责任。除非有法律规定或行政司法机关的指令，且征得复星高照的同意，否则您的用户账户、登录密码、支付密码（如有）和验证码不得以任何方式转让、借用、赠与、继承（与账户相关的财产权益除外）&lt; 或html特殊字符如大于小于号的写法要用原始码，如‘&lt;’原始码为&lt;，‘>’原始码为&gt; 在第三方平台上进行展示或售卖。否则，由此给您（或复星高照、任何第三方）造成的一切损失，概由您自行承担（或者负责赔偿）。
        </strong>
    </p>
    <p
      class="sp_cl"
    >（d）您通过平台发表的信息为公开的信息，其他第三方均可以通过本平台获取用户发表的信息，用户对任何信息的发表即认可该信息为公开的信息，并单独对此行为承担法律责任；任何用户不愿被其他第三人获知的信息都不应在该平台上进行发表。</p>
    <p class="sp_cl">
      <strong>（2）知悉并确认：</strong>
    </p>
    <p class="sp_cl">（a）复星高照因业务发展需要，有权单方面对本服务的全部或部分服务内容在任何时候不经任何通知的情况下变更、暂停、限制、终止或撤销，用户需承担此风险。</p>
    <p
      class="sp_cl"
    >（b）复星高照提供的服务中可能包括广告等活动，用户同意在使用过程中显示复星高照及关联方与第三方供应商、合作伙伴提供的广告以及其他活动。复星高照及/或其关联公司可以通过拨打电话、发送短信或者电子邮件等方式向您注册时填写的手机号码、电子邮箱等发送、告知相应的产品服务广告信息、促销优惠等营销信息；您如果不同意接收相关信息，您可以通过相应的退订功能或相关提示进行退订。</p>
    <p
      class="sp_cl"
    >（c）复星高照有权自行全权决定以任何理由，对违反有关法律法规或本协议约定；或侵犯、妨害、威胁任何人权利或安全的内容；或者假冒他人的行为，有权依法中止、终止传输任何相关内容，并有权依其自行判断对违反本协议的用户采取适当的法律行动，包括但不限于，从服务中删除具有违法性、侵权性、不当性等内容，中止、终止该用户的会员资格，阻止其使用复星高照全部或部分服务，依据法律法规保存有关信息并向有关部门报告等。</p>
    <p
      class="sp_cl"
    >（d）复星高照的某些产品服务必须在联网的情况下才可以使用。您必须自行负担个人上网或第三方（包括但不限于电信或移动通讯提供商）收取的通讯费、信息费等相关费用。如涉及电信增值服务，复星高照建议您与增值服务提供商确认相关费用问题。</p>
    <p
      class="sp_cl"
    >（e）您了解并同意，复星高照有权应政府部门（包括司法及行政部门）的要求，向其提供您在复星高照平台填写的注册信息和发布纪录等必要信息，且无须征得您的同意或提前通知于您。</p>
    <p class="sp_cl">2. 当您按照注册页面提示填写信息、阅读并同意本协议及其他相关协议且完成全部注册程序后，您可获得复星高照平台账户并成为复星高照平台会员。</p>
    <p
      class="sp_cl"
    >3. 您不得通过任何手段恶意注册复星高照平台，包括但不限于以牟利、炒作、套现等为目的多个账号注册。您亦不得盗用其他用户帐号。复星高照平台只允许每位用户使用一个复星高照平台账户。如有证据证明或复星高照根据复星高照平台运营情况判断您存在不当注册或不当使用多个复星高照平台账户的情形，复星高照平台可采取冻结或关闭账户、取消订单、拒绝提供服务等措施，如给复星高照平台及相关方造成损失的，您还应承担赔偿责任。</p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >4. 作为复星高照平台经营者，为使您更好地使用复星高照平台的各项服务，保障您的账户安全，您同意复星高照有权按我国法律规定、监管要求将您的注册信息、身份信息传输给复星高照关联公司或合作的第三方机构完成实名认证。</strong>
    </p>

    <p class="sp_cl">
      <strong>三.用户内容</strong>
    </p>
    <p
      class="sp_cl"
    >1. 用户内容是指该用户下载、发布或以其他方式使用平台与复星高照产品、程序及服务时产生的所有内容（例如：您的信息、文字、图片、音乐或其他内容）；您是您的用户内容唯一的责任人，您将承担因您的用户内容披露而导致的您或任何第三方被识别的风险。</p>
    <p
      class="sp_cl"
    >2. 您通过上传、发行或其他方式使用您在平台与复星高照产品、程序及服务的用户内容时，即视为自动授权且承诺和保证您授权给复星高照不可撤销的、非独家的、免版税的且足额缴纳的全球许可，用以：</p>
    <p
      class="sp_cl"
    >（1）仅为向您提供平台与复星高照产品和程序服务或改进平台与复星高照产品、程序及服务之目的，复制、发行、公开展示和表演、制作衍生作品、将其纳入其他作品或以其他方式使用您的用户账户（排除您的个人信息）；并授予上述事项的转让许可；</p>
    <p class="sp_cl">（2）您同意不可撤销的放弃关于您用户内容的道德权利和归属的声明。</p>
    <p class="sp_cl">
      <strong>四.平台服务</strong>
    </p>

    <p
      class="sp_cl"
    >1. 复星高照通过复星高照平台为您提供平台服务，您可通过复星高照平台上发布各种商品和商业信息、查询用户发布的商品和服务、需求的信息、达成交易、对购买的商品或服务进行评价、发布交易信息、参与复星高照平台活动以及使用其他信息服务及技术服务等；为改善您体验或经营需要，复星高照平台服务的项目和内容可能会不时调整。</p>
    <p class="sp_cl">
      2. 复星高照平台上的商品和服务、需求均系用户销售或提供、发布，而非由复星高照直接销售或提供、发布。
      <strong
        class="sp_underLine"
      >若您利用复星高照平台开展经营活动，您依法独立承担法律责任。为您提供商品/服务的用户与复星高照并非任何法律上及事实上的劳动关系、雇佣关系。复星高照不是您与为您提供商品/服务的商家之间交易的参与者。</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">3. 复星高照不对用户提供的商品/服务或在复星高照平台上发布的信息作任何明示或默示的担保。</strong>
    </p>
    <p class="sp_cl">
      <strong>五.服务费用</strong>
    </p>
    <p
      class="sp_cl"
    >1. 您使用复星高照服务，复星高照保留向您收取相关服务费用的权利，具体各项服务费用以复星高照通知或其他协议为准。如未来复星高照向您收取相关费用的，复星高照会采取合理途径通知您（如在平台公告、弹窗推送、页面提示、短信推送、电子邮件或其他方式），确保您有充分选择的权利。</p>
    <p class="sp_cl">2. 您在使用复星高照服务时，如需向第三方支付费用的，复星高照将在相关页面予以提示或告知您到第三方的平台自行查询相关收费标准等信息。</p>
    <p class="sp_cl">
      <strong>六.用户权利及义务</strong>
    </p>

    <p class="sp_cl">1. 合法使用平台的权利。</p>
    <p class="sp_cl">
      <strong class="sp_underLine">2. 复星高照帐号的所有权归复星高照所有，基于帐号安全性的考虑，禁止使用他人的手机号、邮箱地址注册复星高照帐号。</strong>
      您完成申请注册手续后，获得复星高照帐号的使用权，该使用权仅属于初始申请注册人。复星高照因经营需要，有权回收用户的帐号。
    </p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >3. 您有权更改、删除在平台上的个人资料、注册信息及发布内容等，但需注意，删除有关信息的同时也会删除任何您储存在系统中的文字和图片。用户应承担该风险。</strong>
    </p>
    <p class="sp_cl">4. 通过复星高照平台，您所发布的信息不得含有如下内容：</p>

    <p class="sp_cl">1) 反对宪法所确定的基本原则，煽动抗拒、破坏宪法和法律、行政法规实施的；</p>
    <p class="sp_cl">2)煽动危害国家安全、泄露国家秘密、颠覆国家政权，推翻社会主义制度的；</p>
    <p class="sp_cl">3)煽动分裂国家、破坏国家统一、损害国家荣誉和民族利益的；</p>
    <p class="sp_cl">4)煽动民族仇恨、民族歧视，破坏民族团结的；</p>
    <p class="sp_cl">5)捏造或者歪曲事实，散布谣言，扰乱社会秩序的；</p>
    <p class="sp_cl">6)进行政治宣传或破坏国家宗教政策、宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的；</p>
    <p class="sp_cl">7)公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的；</p>
    <p class="sp_cl">8)损害国家机关信誉的；</p>
    <p class="sp_cl">9)其他违反宪法和法律法规的。</p>
    <p
      class="sp_cl"
    >5. 在复星高照平台上使用复星高照服务过程中，您承诺遵守以下约定：在使用复星高照平台服务过程中实施的所有行为均遵守国家法律、法规等规范文件及复星高照平台各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议及相关规则。您如果违反前述承诺，产生任何法律后果的，您应以自己的名义独立承担所有的法律责任，并确保复星高照免于因此产生任何损失或增加费用。</p>
    <p class="sp_cl">6. 权利限制：</p>
    <p class="sp_cl">（1）您不得对平台内容或复星高照产品、程序及服务（包括但不限于内容或产品中的广告或赞助内容）进行任何形式的许可、出售、租赁、转让、发行或做其他商业用途；</p>
    <p class="sp_cl">（2）您不得以创建相同或竞争服务为目的访问平台或使用复星高照产品、程序及服务；</p>
    <p
      class="sp_cl"
    >（3） 除非法律明文规定，否则您不得对平台或复星高照产品、程序及服务（包括但不限于内容或产品中的广告或赞助内容）的任何部分以任何形式或方法进行复制、发行、再版、下载、显示、张贴、修改、翻译、合并、利用、分解或反向编译等；</p>
    <p
      class="sp_cl"
    >（4）您已同意不在平台或利用复星高照产品、程序及服务从事下列行为：上传或发布电脑病毒、蠕虫、恶意代码、故意破坏或改变计算机系统或数据的软件；未授权的情况下，收集其他用户的信息或数据，例如电子邮箱地址等；</p>
    <p class="sp_cl">（5）干扰、破坏其它用户正常使用平台或复星高照产品、程序及服务。</p>
    <p class="sp_cl">
      <strong>七.用户的违约及处理</strong>
    </p>
    <p class="sp_cl">1. 发生如下情形之一的，视为您违约：</p>

    <p class="sp_cl">（1）使用复星高照平台服务时违反有关法律法规规定的；</p>
    <p class="sp_cl">（2）违反本协议或本协议补充协议约定的。</p>
   <p
      class="sp_cl"
    >由于互联网的特殊性，您理解并同意，复星高照有权根据您的行为与海量用户行为的关系来认定您是否构成违约，您有义务对您的账户异常现象进行充分举证和合理解释，否则将被认定为违约。</p>
    <p class="sp_cl">
      <strong class="sp_underLine">2. 如您构成违约的，复星高照有权视情况采取以下一种或几种处理措施：</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">（1）立即对相应信息进行删除、屏蔽；</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">（2）对您的账户执行账户扣分；</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">（3）中止向您提供部分或全部服务；</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">（4）查封您的账户，终止向您提供服务；</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">（5）要求您支付违约金；</strong>
    </p>

    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >（6）要求您赔偿损失（包括复星高照自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿复星高照的上述全部损失。</strong>
    </p>
    <p class="sp_cl">3. 复星高照可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在复星高照平台上予以公示。</p>
    <p class="sp_cl">
      <strong>八.拒绝提供担保</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">1. 除法律另有规定的以外，复星高照明确表示对在复星高照平台的用户内容、交易服务不提供任何类型的担保，不论是明确的或隐含的。</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">2. 您理解并接受下载或通过复星高照平台服务取得的任何信息资料取决于您自己，并由您承担系统受损或资料丢失的所有风险和责任。</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">3. 复星高照不对以下结果进行保证：</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">（1）不保证复星高照平台上您或其他用户所提供的资料的真实、准确、安全、合法等问题，由此引发的纠纷，由您或其他用户自行承担风险。</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">（2）除另有明确的书面说明外，复星高照平台所承载的内容均为传播资讯目的，不对其真实性、科学性、严肃性做任何形式保证。</strong>
    </p>
    <p class="sp_cl">
      <strong>九.免责声明</strong>
    </p>
    <p class="sp_cl">1. 如发生下述情形，复星高照不承担任何法律责任，包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失的损害赔偿：</p>
    <p class="sp_cl">（1）使用或未能使用复星高照平台服务；</p>
    <p class="sp_cl">（2）依据法律规定或相关政府部门的要求提供您的信息或由于您的使用不当或其他自身原因而导致任何信息的泄露；</p>
    <p
      class="sp_cl"
    >（3）任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足用户要求的情形；</p>
    <p class="sp_cl">
      <strong class="sp_underLine">（4）用户因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形；</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">（5）使用复星高照产品、程序及服务可能存在的来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息而招致的风险；</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">（6）通过复星高照平台服务购买或获取任何商品、样品、数据、信息等行为或替代行为产生的费用及损失；</strong>
    </p>
    <p class="sp_cl">（7）平台和复星高照产品、程序及服务明文声明，不以明示、默示或以任何形式对复星高照及其合作公司服务之及时性、安全性、准确性做出担保。</p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >2. 复星高照仅向您提供复星高照平台服务，您了解复星高照平台上的信息系用户自行发布，用户在平台所发布的任何内容并不代表和反映复星高照的任何观点或政策，由于发布的信息数量较大，且复星高照平台无法杜绝可能存在风险和瑕疵，您应谨慎判断确定相关信息的真实性、合法性和有效性，并注意保留相应的证据以利于维权，复星高照对此不承担任何责任。</strong>
    </p>
    <p
      class="sp_cl"
    >3. 您在复星高照上使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。您和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</p>
    <p
      class="sp_cl"
    >4. 您同意在使用复星高照平台服务过程中显示复星高照自行或由第三方服务商向您发送的推广或宣传信息（包括商业与非商业信息），其方式和范围可不经向您特别通知而变更。除法律法规明确规定外，您应自行对依该推广信息进行的交易负责，对用户因依该推广信息进行的交易或前述第三方服务商提供的内容而遭受的损失或损害，复星高照不承担任何责任。</p>
    <p
      class="sp_cl"
    >5. 您同意您在使用复星高照平台时所发生的风险将完全由您自己承担；因您使用复星高照平台或因商家在复星高照平台上提供的商品/服务而导致的一切后果、损害也由您自行承担，复星高照不对您承担任何责任。</p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >6. 在任何情况下，复星高照均不对您或任何第三方因本协议产生的任何间接性、后果性、惩罚性、偶然性、特殊或惩罚性的损害赔偿承担责任，包括因用户使用复星高照服务而遭受的利润损失，承担责任。</strong>
    </p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >7. 在任何情况下，复星高照对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您在注册期内因使用复星高照服务而支付给复星高照的费用。</strong>
    </p>
    <p class="sp_cl">
      <strong>十.知识产权</strong>
    </p>
    <p
      class="sp_cl"
    >1. 用户在复星高照网站或互动平台上发布的信息不得侵犯任何第三人的知识产权，未经具有相关所有权所有者之事先书面同意，用户不得以任何方式上传、发布、修改、传播或复制任何受著作权保护的材料、商标或属于其他人的专有信息。如果收到任何著作权人或其合法代表发给复星高照的适当通知后，复星高照将在审查的基础上移除该等侵犯他人著作权的内容。</p>
    <p
      class="sp_cl"
    >2. 复星高照服务中所涉及的复星高照标志及产品、服务名称，均为复星高照之著作权。未经复星高照事先书面同意，用户不得将复星高照标识以任何方式展示或使用或作其他处理，任何单位及个人不得以任何方式或理由对该商标的任何部分进行使用、复制、修改、传播、抄录或与其它产品捆绑使用销售。</p>
    <p class="sp_cl">3. 除前述规定以外，如果您认为有人复制并在复星高照网站服务上发布您的作品，并已构成对您著作权的侵犯，请及时与复星高照联系，并提供包含如下信息的书面通知：</p>
    <p class="sp_cl">（1）证明您作为涉嫌侵权内容所有者的权属证明；</p>
    <p class="sp_cl">（2）明确的身份证明、住址、联系方式；</p>
    <p class="sp_cl">（3）涉嫌侵权内容在复星高照服务上的位置；</p>
    <p class="sp_cl">（4）您声称遭受侵犯的著作权作品的描述；</p>
    <p class="sp_cl">（5）您著作权遭受侵犯的相关证明；</p>
    <p class="sp_cl">（6）在同意承担伪证处罚之后果的前提下，出具书面陈述以声明您在通知中所述内容是准确和真实的。</p>
    <p class="sp_cl">
      <strong>十一.修改、终止及注销</strong>
    </p>
    <p class="sp_cl">1. 修改</p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >（1）本协议容许变更。如果本协议有任何实质性变更，复星高照将通过平台公告或短信推送或您提供的电子邮件或其他方式来通知您。变更通知之后，继续使用平台和复星高照产品、程序及服务则视为您已知晓此类变更并同意受条款其约束</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">（2）复星高照保留在任何时候无需通知而修改、保留或关闭平台、复星高照产品、程序或任何服务之权利；</strong>
    </p>
    <p class="sp_cl">（3）您已同意复星高照无需因修改、保留或关闭平台、复星高照产品、程序或其他服务的行为对您或第三方承担责任。</p>
    <p class="sp_cl">2. 终止</p>
    <p class="sp_cl">（1）本协议自您接受之日起生效，在您使用平台和复星高照产品、程序及服务的过程中持续有效，直至依据本协议终止；</p>
    <p
      class="sp_cl"
    >（2）尽管有上述规定，如果您使用平台和复星高照产品、程序及服务的时间早于您接受本协议的时间，您在此知晓或应当知晓并同意本协议于您第一次使用平台和复星高照产品、程序及服务时生效。</p>
    <p class="sp_cl">3. 注销</p>
    <p
      class="sp_cl"
    >您决定不再使用本账户时，应向复星高照申请注销该账户，经复星高照审核同意后可正式注销用户账户。用户死亡或被宣告死亡的，其在本协议项下的各项权利义务由其继承人承担。若用户丧失全部或部分民事权利能力或民事行为能力，复星高照有权根据有效法律文书（包括但不限于生效的法院判决等）或其法定监护人的指示处置与用户账户相关的款项。</p>
    <p
      class="sp_cl"
    >4. 复星高照可能会：依据法律的规定，保留您使用平台、复星高照产品、程序及服务、或者平台账户的权利；无论是否通知，复星高照将在任何时间以任何原因终止本协议，包括出于善意的相信您违反了复星高照可接受使用政策或本协议的其他规定。</p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >5. 一旦本协议终止，您的网站账户和使用平台和复星高照产品、程序及服务的权利即告终止。您应当知晓您的网站账户终止意味着您的用户内容将从复星高照的活动数据库中删除。复星高照不因终止本协议对您承担任何责任，包括终止您的用户账户和删除您的用户内容。</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">6. 任何平台的更新版本或复星高照产品、程序及服务的未来版本、更新或者其他变更将受到本协议约束。</strong>
    </p>
    <p class="sp_cl">
      <strong>十二.其他</strong>
    </p>

    <p class="sp_cl">1. 反馈</p>
    <p
      class="sp_cl"
    >（1）您对复星高照提出建议（或称“反馈”），即视为您向复星高照转让“反馈”的全部权利并同意复星高照有权利以任何合理方式使用此反馈及其相关信息。复星高照将视此类反馈信息为非保密且非专有；</p>
    <p class="sp_cl">（2）复星高照将保留基于自身的判断检查用户内容的权利（而非义务）。无论通知与否，复星高照有权在任何时间以任何理由删除或移动您的用户内容。</p>

    <p class="sp_cl">2. 隐私政策</p>

    <p class="sp_cl">请查阅复星高照的《法律声明及隐私政策》，《法律声明及隐私政策》为与本协议效力等同且不可分割的一部分。</p>
    <p class="sp_cl">3. 通知</p>
    <p
      class="sp_cl"
    >您必须提供您最近经常使用的有效的电子邮件地址。您所提供的电子邮件地址无法使用或者因任何原因复星高照无法将通知送达给您而产生的风险，复星高照不承担责任。平台发布的公告通知及向您所发送的包含此类通知的电子邮件毫无疑问构成有效通知。</p>
    <p class="sp_cl">4. 适用法律</p>
    <p class="sp_cl">（1）本协议适用中华人民共和国法律。</p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >（2）如果双方发生纠纷，应本着友好的原则协商解决；如协商不成，应向杭州市拱墅区人民法院为第一审管辖法院，按照中华人民共和国法律，因级别管辖的规定，杭州市拱墅区人民法院无权管辖的，以其上级法院作为第一审管辖法院。</strong>
    </p>
    <p class="sp_cl">5. 独立性</p>
    <p
      class="sp_cl"
    >（1）本协议中的部分条款无效，不影响其它条款的效力。若上述无效条款构成本协议经济目的之条款或核心条款，则该条款应被尽可能接近各方意图、能够保留本协议要求的经济目的且为有效的新条款所取代。在此情况下，本协议的其它条款仍然有效。</p>
    <p class="sp_cl">（2）平台未行使或执行本使用协议任何权利或规定，不构成对前述权利或权利之放弃。</p>
    <p class="sp_cl">
      <strong>十三.联系方式</strong>
    </p>
    <p class="sp_cl">如果您对本协议有任何问题，请通过以下途径联系复星高照处理，平台会尽最大努力在合理时间内对您的问题进行回复：</p>
    <p class="sp_cl">客服电话： 4000128128 （工作日 9:00-18:00 周末 9:00-17:00）</p>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped lang="less">
.agreement {
  text-align: left;
  padding: 20px;
  .sp_cl {
    text-indent: 2em;
    margin-bottom: 8px;
  }
  .sp_rf {
    text-align: right;
  }
  .sp_underLine {
    text-decoration: underline;
  }
  .center {
    text-align: center;
    margin-bottom: 20px;
  }
}
</style>
